import React, { useState, useRef } from 'react';

import withAppState from '../mobx/withAppState';
import plusIcon from '../assets/img/plus.svg';
import minusIcon from '../assets/img/minus.svg';

const Steps = {
  MENU: 0,
  SPLIT_BY_AMOUNT: 1
};

const elementPlus = <img src={plusIcon} alt="plus" />;
const elementMinus = <img src={minusIcon} alt="minus" />;

function SplitBillMenu(props) {
  const [activeStep, setActiveStep] = useState(Steps.MENU);

  const { handleBackButton, bill: bills } = props;
  const bill = bills && bills.length > 0 ? bills[0] : null;

  if (!bills || bills.length === 0) return null;

  if (activeStep === Steps.MENU) {
    return (
      <main className="split-bill">
        <h2 className="title">Split your bill by?</h2>

        <div className="split-bill-amount-input-container">
          <div className="split-bill-menu-container">
            <button
              className="btn btn-primary split-bill-left"
              onClick={() => setActiveStep(Steps.SPLIT_BY_AMOUNT)}
            >
              Amount
            </button>
            <button
              className={`btn btn-primary split-bill-right ${bill.providerValues['CanSplitByItem'] ===
                  'True'
                  ? ''
                  : 'disabled'
                }`}
              onClick={() => {
                if (
                  bill.providerValues['CanSplitByItem'] ===
                  'True'
                ) {
                  props.initiateSplitByItem();
                } else {
                  props.setErrorModalMessage(
                    'This table cannot be split by item. Please speak to your waiter.'
                  );
                }
              }}
            >
              Items
            </button>
          </div>
        </div>
        <button
          className="btn btn-secondary split-bill-back"
          onClick={handleBackButton}
        >
          Back
        </button>
      </main>
    );
  }
  if (activeStep === Steps.SPLIT_BY_AMOUNT)
    return <SplitByAmount {...props} />;
}

function SplitByAmount(props) {
  const peopleNumberInput = useRef(null);
  const [value, setValue] = useState('');

  const setInputValue = newValue => {
    let numberValue = Number(newValue);
    if ((!!numberValue || numberValue === 0) && numberValue >= 0) {
      if (numberValue > 0 && newValue <= 30) {
        numberValue = Math.floor(numberValue);
        setValue(numberValue);
      } else if (numberValue > 30) {
        setValue(30);
      } else {
        setValue('');
      }
    }
  };

  const { loading } = props;
  return (
    <main className="split-bill">
      <p className="user-instructions">
        How many people would you like to split by?
      </p>

      <div className="split-bill-menu-container">


        <div className="split-bill-amount-input-container">
          <div className="split-bill-controls"> 
            <button
            tabIndex={0}
              disabled={value <= 0 }
              className="picker"
              value={-1}
              onClick={() => {
                setInputValue(value - 1);
              }}
            >
              {elementMinus}
            </button>
            <input
            autoFocus
              className="guest-picker"
              type="tel"
              ref={peopleNumberInput}
              placeholder="0"
              value={value}
              onChange={e => {
                setInputValue(e.target.value);
              }}
            />
            <button
            tabIndex={0}
              className="picker"
              value={1}
              onClick={() => {
                setInputValue(value + 1);
              }}
            >
              {elementPlus}
            </button>
          </div>
        </div>
        <div>
        </div>
      </div>
      <button
        className={`btn btn-primary split-bill-confirm ${loading === false ? '' : 'disabled'
          }`}
        onClick={() => props.initiateSplit(value)}
      >
        {loading === false ? (
          'Confirm'
        ) : (
          <div className="cta-dual-ring"></div>
        )}
      </button>
    </main>
  );
}

export default withAppState(SplitBillMenu,
  {
    mobXProps: ({
      bill,
    }) => ({
      bill,
    }),
    mobXActions: ({
      updateBillTotalAndSplit,
      setErrorModalMessage,
    }) => ({
      updateBillTotalAndSplit,
      setErrorModalMessage,
    })
  }
);